import { authHeader,check419 } from "../helpers";

// import dateFormat from "dateformat";

export const reportEquipmentUsedBookingService = {
    getReport,
    getReportExport,
  
};


function getReport(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };
    return fetch(
        process.env.REACT_APP_APIURL + "report-equipment-used-booking/get-report",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}
function getReportExport(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "report-equipment-used-booking/get-report-export",
        requestOptions,
    )
        .then(handleResponse)
        .then(bookingList => {
            return bookingList;
        });
}


function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        //const data = text;
        if (!response.ok) {
            if (response.status === 400) {
                // auto logout if 401 response returned from api
                // logout();
                // location.reload(true);
                const error = (data && data.data.errors) || response.statusText;
                return Promise.reject(error);
            } else if(response.status === 419){
                check419();
            }

            // const error = (data && data.message) || response.statusText;
            // return Promise.reject(error);
        }

        return data;
    });
}
